import React, {useContext} from 'react';
import Search from 'antd/es/input/Search';
import {sideMenuContext} from '../../../router/IndexRouter';

const SearchBox = ({placeholder = '输入姓名或单位关键字'}) => {
	const {setDataSource, copyDataSource} = useContext(sideMenuContext);
	const onSearch = (searchContent) => {
		if (searchContent.length > 0) {
			const searchResult = copyDataSource.filter(party => (
				party.peopleName?.includes(searchContent)
				|| party.peopleUnit?.includes(searchContent)
				|| party.memberName?.includes(searchContent)
				|| party.memberUnit?.includes(searchContent)
				|| party.memberUnitName?.includes(searchContent)
				|| party.partyMemberName?.includes(searchContent)
				|| party.partyMemberUnit?.includes(searchContent)
				|| party.party_member_name?.includes(searchContent)
				|| party.party_member_unit?.includes(searchContent)
				|| party.member_name?.includes(searchContent)
				|| party.member_unit?.includes(searchContent)
				|| party.organizationName?.includes(searchContent)
				|| party.organization_name?.includes(searchContent)
				|| party.establishUnit?.includes(searchContent)
				|| party.nickname?.includes(searchContent)
				|| party.title?.includes(searchContent)
				|| party.peopleZzmm?.includes(searchContent)
				|| party.memberZzmm?.includes(searchContent)
			));
			setDataSource(searchResult);
		} else {
			setDataSource(copyDataSource);
		}
	};
	return (
		<Search
			style={{float: 'right', width: 300, marginBottom: 10}}
			placeholder={placeholder}
			onSearch={onSearch}
			enterButton
		/>
	);
};

export default SearchBox;
